/// <amd-module name="Build/Common/Artifacts/Action" />
import { BuildArtifact, Build } from "Build/Client/Contracts/Build";
import { IBuildRestClient } from "Build/Client/RestClient/Build";

import { handleError } from "Build/Common/Library/ErrorHandler";
import { Action } from "Build/Flux/Action";

import { ArtifactsSource } from "Build/Common/Artifacts/Source";

export interface IArtifactsActionCreatorOptions {
    projectId: string;
    client: IBuildRestClient;
    actionHub?: ArtifactsActionHub;
}

export class ArtifactsActionCreator {
    private _actionHub: ArtifactsActionHub;
    private _source: ArtifactsSource;

    constructor(options: IArtifactsActionCreatorOptions) {
        this._actionHub = options.actionHub || new ArtifactsActionHub();
        this._source = new ArtifactsSource({
            client: options.client,
            projectId: options.projectId
        });
    }

    public fetchArtifacts(buildId: number) {
        this._source.getArtifacts(buildId)
            .then(x => this._actionHub.artifactsAvailable.invoke(x))
            .catch(handleError);
    }

    public fetchArtifact(buildId: number, name: string) {
        this._source.getArtifact(buildId, name)
            .then(x => this._actionHub.artifactAdded.invoke(x))
            .catch(handleError);
    }
}


export class ArtifactsActionHub {
    private _artifactAdded: Action<BuildArtifact>;
    private _artifactsAvailable: Action<BuildArtifact[]>;

    constructor() {
        this._artifactAdded = new Action<BuildArtifact>();
        this._artifactsAvailable = new Action<BuildArtifact[]>();
    }

    public get artifactAdded(): Action<BuildArtifact> {
        return this._artifactAdded;
    }

    public get artifactsAvailable(): Action<BuildArtifact[]> {
        return this._artifactsAvailable;
    }
}
